<template>
  <div>
    <div class="footer pc">
      <div class="content-box auto-content">
        <div
          class="group"
          v-for="(item, index) in groupData"
          :key="'footer' + index"
        >
          <p v-if="item.title" class="outline">{{ item.title }}</p>
          <div v-if="item.group" class="link-btn">
            <div v-for="(items, i) in item.group" :key="'group' + i">
              <p v-if="index === 0 || index === 1" class="text">
                <router-link class="link-style" :to="items.link">{{
                  items.text
                }}</router-link>
              </p>
              <p v-else class="text">{{ items.text }}</p>
              <p class="con" v-if="items.con">{{ items.con }}</p>
            </div>
          </div>
          <p class="pic"><img v-if="item.img" :src="item.img" alt="" /></p>
        </div>
      </div>
    </div>

    <div class="mobile mobile-bg-q">
      <div class="mobile-title">
        <div class="col-6" v-for="(item, index) in groupData" :key="index">
          <p
            class="mobile-title-text"
            @click="lookGroup(item.group, index)"
            :class="selectIndex == index ? 'mobile-link-select' : ''"
          >
            {{ item.title }}
          </p>
        </div>
      </div>
      <div class="mobile-group">
        <div
          class="mobole-group-item"
          v-for="(item, index) in footerGroup"
          :key="index"
        >
          <p v-if="item.link" class="mobile-link">
            <router-link class="link-style" :to="item.link">{{
              item.text
            }}</router-link>
          </p>
          <p v-else class="text">
            {{ item.text }}
          </p>
          <p class="con" v-if="item.con">{{ item.con }}</p>
        </div>
        <p class="pic"><img src="../../../assets/app-g.jpg" alt="" /></p>
      </div>
    </div>

    <div class="footer-b">
      <img src="../../../assets/logo.png" alt="" />
      <p>
        <a class="copyright" target="_blank" href="https://beian.miit.gov.cn"
          >版权所有 © 一石数字技术成都有限公司 蜀ICP备18032884号</a>
      </p>
      <p>
        <a
          class="copyright"
          target="_blank"
          href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=51019002001832"
        >
          川公网安备 51019002001832号</a
        >
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {
      footerGroup: [],
      selectIndex: 0,
      groupData: [
        {
          title: "关于一石",
          group: [
            {
              text: "公司简介",
              link: "/about/us",
            },
            // {
            //   text: "公司咨询",
            //   link: "/service",
            // },
            {
              text: "加入我们",
              link: "/about/join",
            },
          ],
        },
        {
          title: "解决方案",
          group: [
            {
              text: "智安园区",
              link: "/cases/lists",
            },
            {
              text: "智慧园区",
              link: "/cases/house",
            },
            {
              text: "公共安全",
              link: "/cases/safe",
            },
            {
              text: "光纤入侵检测",
              link: "/cases/optical",
            },
            {
              text: "智慧变电站",
              link: "/cases/zhihui",
            },
          ],
        },
        {
          title: "联系我们",
          group: [
            {
              text: "地址 / Address",
              con: "成都市高新区盛安街133号汇锦广场A座 17F",
              link: "",
            },
            {
              text: "电话 / Phone",
              con: "028-8669-5987",
              link: "",
            },
            {
              text: "邮箱 / Email",
              con: "support@yishi-ai.com",
              link: "",
            },
          ],
        },
        {
          title: "商务合作",
          group: [
            {
              text: "商务合作",
              con: "market@yishi-ai.com",
              link: "",
            },
            {
              text: "技术支持",
              con: "support@yishi-ai.com",
              link: "",
            },
            {
              text: "投递简历",
              con: "job@yishi-ai.com",
              link: "",
            },
          ],
        },
        {
          img: require("../../../assets/app-g.jpg"),
        },
      ],
    };
  },
  created() {
    this.footerGroup = this.groupData[0].group;
  },
  methods: {
    lookGroup(group, index) {
      this.footerGroup = group;
      this.selectIndex = index;
    },
  },
};
</script>

<style scoped>
.footer {
  width: 100%;
  background: #f8f9fb;
  padding: 60px 0;
}
.auto-content {
  display: flex;
  justify-content: space-between;
}
.group {
  padding-left: 30px;
}
.outline {
  font-size: 12px;
  font-weight: 500;
  color: #f08d00;
  margin-bottom: 20px;
}
.link-btn {
  font-size: 12px;
  font-weight: 400;
  color: #333333;
}
.text {
  margin-top: 10px;
}
.con {
  line-height: 20px;
}
.pic img {
  width: 102px;
  height: 102px;
}
.footer-b {
  width: 100%;
  height: 116px;
  text-align: center;
}
.footer-b img {
  margin-top: 18px;
}
.copyright {
  font-size: 12px;
  font-weight: 400;
  color: #999999;
  line-height: 17px;
  text-decoration: none;
}
.link-style {
  color: #333333;
  text-decoration: none;
}
.link-style:hover {
  color: #f08d00;
}
</style>
<style scoped>
@media screen and (max-width: 750px) {
  .mobile-title {
    width: 100%;
    height: 1rem;
    border-bottom: 0.01rem solid #f8f9fb;
    /* padding: 0 0.46rem; */
  }
  .col-6 {
    width: 25%;
    text-align: center;
    float: left;
  }

  .mobile-title-text {
    height: 0.44rem;
    line-height: 0.44rem;
    font-size: 0.32rem;
    font-weight: 400;
    color: #666666;
    border-right: 0.01rem solid #f8f9fb;
    margin-top: 0.28rem;
  }
  .col-6:last-child .mobile-title-text {
    border-right: none;
  }

  .mobile-group {
    position: relative;
    height: 2.6rem;
    padding: 0.6rem 0.48rem;
  }
  .pic {
    position: absolute;
    bottom: 0.48rem;
    right: 0.48rem;
    z-index: 1;
  }
  .pic img {
    width: 1.55rem;
    height: 1.55rem;
  }
  .mobole-group-item {
    font-size: 0.24rem;
    font-weight: 400;
    color: #333333;
  }
  .mobile-link {
    font-family: PingFangSC-Regular, PingFang SC;
    margin-bottom: 0.2rem;
    color: #666666;
  }
  .mobile-link-select {
    font-weight: 500;
    color: #333333;
    font-family: PingFangSC-Medium, PingFang SC;
  }
  .text {
    margin-top: 0;
    margin-bottom: 0.09rem;
    color: #333333;
  }
  .con {
    margin-bottom: 0.2rem;
    color: #333333;
  }
  .footer-b {
    /* background: #f0f2f5; */
  }
}
</style>
